var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio-group',_vm._g(_vm._b({ref:"radioGroup",attrs:{"value":_vm.value,"row":_vm.row,"hide-details":_vm.hideDetails,"dense":_vm.dense}},'v-radio-group',_vm.forwarded_attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }